"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.file_forwardedTape = void 0;
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const commonTapeNode_1 = require("../../commonTapeNode");
const utils_1 = require("../../utils");
const types_1 = require("./types");
const { isNode, isIntermediateRecord, ...otherProps } = (0, commonTapeNode_1.commonTapeNodeUtils)(types_1.nodeType, types_1.artifactType, types_1.UIConfigSchema);
// create a new UI node of this type.
const createNewNode = ({ id, suggestedSerialNumber, nodeToCopy, }) => {
    const friendlyName = `Sftp Fowarded Tape`;
    const nodeData = {
        metadata: {
            tapeBuilderNodeId: id,
            tapeBuilderNodeType: types_1.nodeType,
        },
        configuration: {
            artifactSlug: `${_.camelCase(friendlyName)}_${suggestedSerialNumber}`,
            config: {
                type: 'sftp',
                sftpConnection: {
                    host: 'sftp@hostname.com',
                    username: 'username',
                    port: 22,
                    authType: 'password',
                    ssmCredPath: '/SECRETS/PATH/TO/SECRET',
                },
                outputs: [
                    {
                        inputArtifactSlug: 'inputArtifactSlugName',
                        baseFilename: 'outputBaseFilename',
                        ext: 'csv',
                        path: '/folder/path/for/upload',
                    },
                ],
            },
        },
    };
    if (nodeToCopy) {
        (0, common_1.finleyAssert)(isNode(nodeToCopy), `node must be a ${types_1.nodeType} node`);
        nodeData.configuration = _.cloneDeep(nodeToCopy.configuration);
        nodeData.configuration.artifactSlug = (0, utils_1.updateArtifactSlug)(nodeData.configuration.artifactSlug, suggestedSerialNumber);
        nodeData.configuration.config.outputs = nodeData.configuration.config.outputs.map((ftpConfig) => ({ ...ftpConfig, baseFilename: 'PLACEHOLDER' }));
    }
    return nodeData;
};
/*
 * validate the configuration for the node. This checks shape as well
 * logical correctness.
 * This function should validate the config wrt rest of the graph as well.
 * if there is an error it should return an array of error messages.
 * if there are no errors it should return an empty array.
 */
const hasValidConfig = ({ graph, node, getUINode, }) => {
    (0, common_1.finleyAssert)(isNode(node), `node must be a ${types_1.nodeType} node`);
    return (0, utils_1.checkEdges)({
        node,
        graph,
        isAllowedInputNode: () => true,
        getUINode,
        minInputs: 1,
        maxInputs: 100,
        minOutputs: 0, // for now, this is terminal node
        maxOutputs: 0, // for now, this is terminal node
    });
};
// validate given IntermediateRecord.
// this is called after initial Config validation is done
// and the intermediate record is generated.
// here an instance of ITapeBuilder is available, which can be used
// to inspect any Tape definitions.
const validateIntermediateTape = ({ graph, tape, }) => {
    (0, common_1.finleyAssert)(isIntermediateRecord(tape), `validateIntermediateTape: tape is not an ${types_1.artifactType}`);
    (0, common_1.finleyAssert)(tape.type === 'forwardedTape', `node is not a forwardedTape, found: [tape.type:${tape.type}]`);
    const configErrors = [];
    // validate that the input node slugs exist
    const inputIds = (0, utils_1.getInputTapeIds)({ tapeId: tape.id, graph });
    const inputArtifactSlugs = inputIds.map((inputId) => {
        const inputTape = (0, utils_1.getTapeById)({ tapeId: inputId, graph });
        (0, common_1.finleyAssert)(inputTape, `input tape must exist for [inputId:${inputId}]`);
        return inputTape.artifactSlug;
    });
    const { configuration } = tape;
    switch (configuration.config.type) {
        case 'sftp': {
            configuration.config.outputs.forEach((output) => {
                if (!inputArtifactSlugs.includes(output.inputArtifactSlug)) {
                    configErrors.push(`forwardedTape: Tape output configuration contains unknown [inputArtifactSlug:${output.inputArtifactSlug}]`);
                }
            });
            break;
        }
        default:
            (0, common_1.finleyAssertUnreachable)(configuration.config.type);
    }
    configuration.config.outputs.forEach((output) => {
        if (output.path) {
            if (output.path.length === 0) {
                configErrors.push(`Empty path detected for ${output.inputArtifactSlug}`);
            }
            if (output.path.length > 0 && output.path[0] !== '/') {
                configErrors.push(`Path configuration should start with "/" for ${output.inputArtifactSlug}`);
            }
            if (output.path.length > 0 &&
                output.path[output.path.length - 1] === '/') {
                configErrors.push(`Path configuration should not end with "/" for ${output.inputArtifactSlug}`);
            }
        }
    });
    return configErrors;
};
/**
 * Represents a UI node with various properties and methods.
 */
exports.file_forwardedTape = {
    // what should node say on the tape-builder node creation menu.
    nodeTypeText: 'Forward',
    // what is the node type. must be one of the constants defined in TapeBuilderNodeType
    nodeType: types_1.nodeType,
    // expose artifactType
    artifactType: types_1.artifactType,
    isOperation: false,
    isRaw: false,
    isFinal: true,
    // operation nodes dont render badges.
    badgeTexts: ['ForwardedTape'],
    // creates sample configuration for this node.
    createNewNode,
    // typeguard that checks if the node is of this type.
    isNode,
    isIntermediateRecord,
    ...otherProps,
    // validate the configuration for the node for logical correctness
    hasValidConfig,
    // validate generated config
    validateIntermediateTape,
};
//# sourceMappingURL=uinode.js.map